var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{staticStyle:{"background-color":"#fdfafa"}},[_c('Navbar'),_c('div',{staticStyle:{"height":"130px"}}),_c('router-view',{staticClass:"container"}),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }